import { BACKEND_URL } from '../../config'
import { get } from '../../common/network-client'

export const fetchTracker = async (id, after, before) => {
  const queryString = buildQueryString(id, after, before)
  const response = await get(`${BACKEND_URL}/tracking/queries/get-tracker${queryString}`)
  return response.data
}

function buildQueryString(id, after, before) {
  let queryString = `?id=${id}`
  if (after && before) {
    queryString += `&after=${after.toISOString()}&before=${before.toISOString()}`
  }
  return queryString
}
